import { Minus, Plus, Eye } from 'lucide-react'
import { useAccessibility } from '../contexts/AccessibilityContext'

export function AccessibilityBar() {
  const { fontSize, highContrast, increaseFontSize, decreaseFontSize, toggleHighContrast } =
    useAccessibility()

  return (
    <div
      className="bg-[#51A64D] text-white text-sm"
      role="toolbar"
      aria-label="Barra de acessibilidade"
    >
      <div className="container flex items-center justify-between py-1.5 gap-2 flex-wrap">
        <a href="#conteudo-principal" className="skip-link">
          Pular para conteúdo
        </a>

        <div className="flex items-center gap-1">
          <span className="hidden sm:inline mr-1 font-medium text-xs uppercase tracking-wide opacity-80">
            Acessibilidade:
          </span>

          <button
            onClick={decreaseFontSize}
            disabled={fontSize === 0}
            className="flex items-center gap-1 px-2 py-0.5 rounded hover:bg-white/20 transition-colors disabled:opacity-40 text-xs"
            aria-label="Diminuir fonte"
            title="Diminuir fonte"
          >
            <Minus size={12} />
            <span className="hidden sm:inline">A-</span>
          </button>

          <button
            onClick={increaseFontSize}
            disabled={fontSize === 2}
            className="flex items-center gap-1 px-2 py-0.5 rounded hover:bg-white/20 transition-colors disabled:opacity-40 text-xs"
            aria-label="Aumentar fonte"
            title="Aumentar fonte"
          >
            <Plus size={12} />
            <span className="hidden sm:inline">A+</span>
          </button>

          <button
            onClick={toggleHighContrast}
            className={`flex items-center gap-1 px-2 py-0.5 rounded transition-colors text-xs ${
              highContrast
                ? 'bg-white text-[#51A64D] font-bold'
                : 'hover:bg-white/20'
            }`}
            aria-label={highContrast ? 'Desativar alto contraste' : 'Ativar alto contraste'}
            title={highContrast ? 'Desativar alto contraste' : 'Ativar alto contraste'}
            aria-pressed={highContrast}
          >
            <Eye size={12} />
            <span className="hidden sm:inline">Contraste</span>
          </button>
        </div>

        <div className="flex items-center gap-3 text-xs opacity-80">
          <span className="hidden md:inline">Prefeitura Municipal de Porto Velho</span>
        </div>
      </div>
    </div>
  )
}